import { Routes } from '@angular/router';
import { authLoginGuard } from '@core/guards/auth.login.guard';
import { permissionsGuard } from '@core/guards/permissions.guard';
import { LayoutComponent } from '@shared/layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivateChild: [authLoginGuard],
    children: [
      {
        path: 'terminal-customer',
        loadChildren: () => import('./pages/terminal-customer/terminal-customer.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: ['pay_terminal_customer_view'],
        },
      },
      {
        path: 'merchant',
        loadChildren: () => import('./pages/merchant/merchant.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: ['pg_merchant_view'],
        },
      },
      {
        path: 'reports',
        loadChildren: () => import('./pages/reports/reports.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: ['asset_view_user_terminal_wallet_report', 'terminals_transaction_report'],
        },
      },
      {
        path: 'terminal-add-deduct',
        loadChildren: () => import('./pages/terminal-add-deduct/terminal-add-deduct.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: ['pg_terminal_add_deduct_view'],
        },
      },
      {
        path: 'terminal-cgpay',
        loadChildren: () => import('./pages/terminal-cg-pay/terminal-cg-pay.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: ['cgpay_terminal_view'],
        },
      },
      {
        path: 'transactions',
        loadChildren: () => import('./pages/transactions/transactions.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: ['transaction_payin_view', 'transaction_payout_view', 'crypto_admin_direct_deposit_transactions_list_view'],
        },
      },
      {
        path: 'addresses',
        loadChildren: () => import('./pages/address/address.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: ['crypto_admin_direct_deposit_addresses_list_view'],
        },
      },
      {
        path: 'wallet',
        loadChildren: () => import('./pages/wallet/wallet.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: [''],
        },
      },
      {
        path: 'wallet-address',
        loadChildren: () => import('./pages/wallet-address/wallet-address.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: ['wallet_address_view'],
        },
      },
      {
        path: 'dev-space',
        loadChildren: () => import('./pages/dev-space/dev-space.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: ['webhook_management_view', 'provider_webhook_view'],
        },
      },
      {
        path: 'access-denied',
        loadComponent: () => import('./shared/components/access-denied/access-denied.component'),
      },
      {
        path: 'ipg',
        loadChildren: () => import('./pages/ipg/ipg.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: ['ipg_report_info', 'ipg_report_asset_balance'],
        },
      },
      {
        path: 'crypto-settings',
        loadChildren: () => import('./pages/crypto-settings/crypto-settings.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: [
            'crypto_currency_blockchain_network_view',
            'crypto_currency_blockchain_network_currency_view',
            'crypto_currency_crypto_provider_view',
            'crypto_currency_crypto_provider_api_account_view',
            'crypto_currency_crypto_wallet_view',
          ],
        },
      },
      {
        path: 'configuration',
        loadChildren: () => import('./pages/configuration/configuration.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: ['crypto_currency_view', 'idp_view_role_team_member_list'],
        },
      },
      {
        path: 'user-management',
        loadChildren: () => import('./pages/user-management/user-management.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: ['idp_view_manager_list', 'idp_view_role_list', 'idp_view_customers', 'idp_view_user_group_list'],
        },
      },
      {
        path: 'report/wallet',
        loadChildren: () => import('./pages/wallet-report/wallet-report.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: ['wallet_service_view_wallet_transactions', 'wallet_view_list'],
        },
      },
      {
        path: 'finance',
        loadChildren: () => import('./pages/finance/finance.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: ['wallet_view_balances', 'wallet_correction_request_view_list'],
        },
      },
      {
        path: 'request',
        loadChildren: () => import('./pages/request/request.routes'),
        canActivate: [permissionsGuard],
        data: {
          permissions: ['settlement_view_request_list'],
        },
      },
      {
        path: 'profile',
        loadChildren: () => import('./pages/my-profile/my-profile.routes'),
      },
    ],
  },

  {
    path: '**',
    redirectTo: '/',
  },
];
